import './Stack.css';
export default {
    "root": "Stack_root__1ksk7"
};
